import { Input, Form, LegacyPage } from 'peach/components'
import { withFormValue } from 'peach/decorators'

import CodeEditor from './CodeEditor'

const TemplateEditor = ({ value, onChange }) => (
  <LegacyPage.Full>
    <Form.Provider onChange={onChange} value={value || {}}>
      <Input formKey='subjectLineTemplate' />
      <CodeEditor formKey='contentHtmlTemplate' />
      <CodeEditor formKey='contentTextTemplate' />
    </Form.Provider>
  </LegacyPage.Full>
)

export default withFormValue(TemplateEditor)
